import i18nFactory from '@yandex-int/i18n';
import { RadioButton } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { CREATIVE_POSITION_OPTION_VALUES, CreativePositionOptionValue as Value } from '../typings';

import './CreativePositionOption.css';
import * as keyset from './CreativePositionOption.i18n';

const i18n = i18nFactory(keyset);

export interface CreativePositionOptionProps {
    value: string;
    allowedValues: Value[];
    click: (value: string) => void;
}

const BLOCK = 'creative-position-option';

export class CreativePositionOption extends React.PureComponent<CreativePositionOptionProps> {
    render(): React.ReactNode {
        const { value, allowedValues } = this.props;
        return (
            <div className={BLOCK}>
                <div className={Bem.cls(BLOCK, 'value')}>{this.getTextValue()}</div>
                <div className={Bem.cls(BLOCK, 'position-items')}>
                    <RadioButton
                        size={'s'}
                        theme={'normal'}
                        view={'classic'}
                        value={value}
                        onChange={this.onClick}
                        cls={Bem.cls(BLOCK, 'position-line')}
                    >
                        {CREATIVE_POSITION_OPTION_VALUES.slice(0, 3).map((position: Value) => (
                            <RadioButton.Radio
                                value={position}
                                key={position}
                                cls={Bem.cls(BLOCK, 'position-item', {
                                    'left-top': position === Value.LeftTop,
                                    'right-top': position === Value.RightTop
                                })}
                                disabled={!allowedValues.includes(position)}
                            />
                        ))}
                    </RadioButton>
                    <RadioButton
                        size={'s'}
                        theme={'normal'}
                        view={'classic'}
                        value={value}
                        onChange={this.onClick}
                        cls={Bem.cls(BLOCK, 'position-line')}
                    >
                        {CREATIVE_POSITION_OPTION_VALUES.slice(3, 6).map((position: Value) => (
                            <RadioButton.Radio
                                value={position}
                                key={position}
                                cls={Bem.cls(BLOCK, 'position-item')}
                                disabled={!allowedValues.includes(position)}
                            />
                        ))}
                    </RadioButton>
                    <RadioButton
                        size={'s'}
                        theme={'normal'}
                        view={'classic'}
                        value={value}
                        onChange={this.onClick}
                        cls={Bem.cls(BLOCK, 'position-line')}
                    >
                        {CREATIVE_POSITION_OPTION_VALUES.slice(6, 9).map((position: Value) => (
                            <RadioButton.Radio
                                key={position}
                                value={position}
                                cls={Bem.cls(BLOCK, 'position-item', {
                                    'left-bottom': position === Value.LeftBottom,
                                    'right-bottom': position === Value.RightBottom
                                })}
                                disabled={!allowedValues.includes(position)}
                            />
                        ))}
                    </RadioButton>
                </div>
            </div>
        );
    }

    private getTextValue(): string {
        const { value } = this.props;

        switch (value) {
            case Value.LeftTop:
                return i18n('left-top');
            case Value.CenterTop:
                return i18n('center-top');
            case Value.RightTop:
                return i18n('right-top');
            case Value.LeftCenter:
                return i18n('left-center');
            case Value.CenterCenter:
                return i18n('center-center');
            case Value.RightCenter:
                return i18n('right-center');
            case Value.LeftBottom:
                return i18n('left-bottom');
            case Value.CenterBottom:
                return i18n('center-bottom');
            case Value.RightBottom:
                return i18n('right-bottom');
            default:
                return i18n('default');
        }
    }

    private onClick = (event: React.ChangeEvent<HTMLInputElement>): void => {
        this.props.click(event.target.value);
    };
}
